export default function UserProfileCollection(getAllowanceRecord) {
    let active;

    if (getAllowanceRecord.active === 0) {
        active = 'Inactive';
    } else {
        active = 'Active';
    }

    return ({
        employeeName: `${getAllowanceRecord.employee_name}`,
        managerName: `${getAllowanceRecord.manager_name}`,
        staffNo: `${getAllowanceRecord.staff_no}`,
        position: `${getAllowanceRecord.position}`,
        mail: `${getAllowanceRecord.mail}`,
        staffDuty: `${getAllowanceRecord.staff_duty}`,
        entryDate: `${getAllowanceRecord.entry_date}`,
        active: `${active}`,
        location: `${getAllowanceRecord.location.name}`,
        department: `${getAllowanceRecord.department.name}`,
    });
}
